module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/tee/7-ae3c790901dd10ac99fa69b190e38444.jpg";